import RestClient from '../../../lib/RestClient';

const URL = '/logistics-avalanche/';
const URL_Movements = URL + "movements/"
const URL_LIVE = "/logistics-live";

class LogisticsAvalancheService {
    public getAllAccounts(
        sortColumn: String, sortOrder: String, pageToLoad: number, count: number, filter:string
    ) {
        return RestClient.get(URL + "/accounts", {sortBy: sortColumn, sortDirection: sortOrder, page: pageToLoad, count: count, filter: filter});
    }

    public getAllInventoryData(sortColumn: String, sortOrder: String, pageToLoad: number, count: number, filter:string) {

        return RestClient.get(URL_LIVE, {sortBy: sortColumn, sortDirection: sortOrder, page: pageToLoad, count: count, filter: filter});
    }

    public getInventoryAggregations(kontoNr: String, ltNummer: String, sortColumn: String, sortOrder: String, page?: number, count?: number) {
        return RestClient.get(URL_LIVE + "/region/" + kontoNr + "/" + ltNummer, {sortBy: sortColumn, sortDirection: sortOrder, page: page || 0, count: count || 1000});
    };

    public getInventoryAggregationsMarkt(kontoNr: String, ltNummer: String, sortColumn: String, sortOrder: String, page?: number, count?: number) {
        return RestClient.get(URL_LIVE + "/" + kontoNr + "/" + ltNummer, {sortBy: sortColumn, sortDirection: sortOrder, page: page || 0, count: count || 1000});
    };

    public getInventoryAggregationsForRegion(kontoNr: String, ltNummer: String, region: String, sortColumn: String, sortOrder: String, page?: number, count?: number) {
        return RestClient.get(URL_LIVE + "/" + kontoNr + "/" + ltNummer + "/" + region, {sortBy: sortColumn, sortDirection: sortOrder, page: page || 0, count: count || 1000});
    };

    public getInventoryDataForAccountAndLTNumberAndMarket(kontoNr: String, ltNummer: String, markt: String, sortColumn: String, sortOrder: String, pageToLoad: number, count: number) {
        return RestClient.get(URL + kontoNr + "/" + ltNummer + "/" + markt, {sortBy: sortColumn, sortDirection: sortOrder, page: pageToLoad, count: count});
    }

    public getMovementsForAccountAndLTAndMarket(account: String, ltNummer: String, markt: String, sortColumn: String, sortOrder: String, pageToLoad: number, count: number) {
        return RestClient.get(URL_Movements + account + "/" + ltNummer + "/" + markt, {sortBy: sortColumn, sortDirection: sortOrder, page: pageToLoad, count: count});
    }
}

const LogisticsAvalancheServiceSingleton = new LogisticsAvalancheService();

export default LogisticsAvalancheServiceSingleton;
